import React, { useState } from 'react';
import Header from '../components/menu/header';
import Footer from '../components/menu/footer';
import './contatti.css';

const Contatti = () => {
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    email: '',
    oggetto: '',
    messaggio: ''
  });
  
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Rimuovi errore quando l'utente inizia a digitare
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.nome.trim()) {
      newErrors.nome = 'Il nome è obbligatorio';
    }
    
    if (!formData.cognome.trim()) {
      newErrors.cognome = 'Il cognome è obbligatorio';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'L\'email è obbligatoria';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Inserisci un\'email valida';
    }
    
    if (!formData.oggetto.trim()) {
      newErrors.oggetto = 'L\'oggetto è obbligatorio';
    }
    
    if (!formData.messaggio.trim()) {
      newErrors.messaggio = 'Il messaggio è obbligatorio';
    } else if (formData.messaggio.trim().length < 10) {
      newErrors.messaggio = 'Il messaggio deve contenere almeno 10 caratteri';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Simula un piccolo delay per l'esperienza utente
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Crea il link mailto
      const subject = encodeURIComponent(formData.oggetto);
      const body = encodeURIComponent(
        `Nome: ${formData.nome} ${formData.cognome}\n` +
        `Email: ${formData.email}\n\n` +
        `Messaggio:\n${formData.messaggio}`
      );
      
      const mailtoLink = `mailto:ads.bologna@gmail.com?subject=${subject}&body=${body}`;
      
      // Apri il client email
      window.location.href = mailtoLink;
      
      // Mostra messaggio di successo
      setShowSuccess(true);
      
      // Reset form
      setFormData({
        nome: '',
        cognome: '',
        email: '',
        oggetto: '',
        messaggio: ''
      });
      
      // Nasconde il messaggio di successo dopo 5 secondi
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
      
    } catch (error) {
      console.error('Errore durante l\'invio:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = '3497505235';
    const message = encodeURIComponent('Ciao! Ho visto il vostro sito e vorrei maggiori informazioni sullo Scoutball.');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleInstagramClick = () => {
    const instagramUrl = 'https://www.instagram.com/amanti.dello.scoutball/';
    window.open(instagramUrl, '_blank');
  };

  return (
    <div className="contatti-page">
      <Header />

      {/* Hero Section */}
      <section className="contatti-hero">
        <div className="contatti-hero-content">
          <h1>CONTATTI</h1>
        </div>
      </section>

      {/* Main Content */}
      <main className="contatti-main">
        <div className="contatti-container">
          
          <section className="contatti-section contatti-info-section">
            <div className="contatti-section-header">
              <h2>
                <i className="fas fa-info-circle"></i>
                Siamo qui per aiutarti
              </h2>
            </div>
            <div className="contatti-info-content">
              <div className="contatti-info-text">
                <p>
                  Che tu sia interessato a partecipare a un torneo, organizzare un evento nella tua zona, 
                  o semplicemente conoscere meglio il mondo dello Scoutball, siamo sempre disponibili 
                  per rispondere alle tue domande e supportarti nel tuo percorso.
                </p>
              </div>
            </div>
          </section>
          {/* Sezione Contatti Social - Un unico contenitore */}
          <section className="contatti-section contatti-social-section">
            <div className="contatti-section-header">
              <h2>
                <i className="fas fa-share-alt"></i>
                Contatti Social
              </h2>
            </div>
            <div className="contatti-content">
              <div className="contatti-social-buttons">
                <button 
                  onClick={handleWhatsAppClick}
                  className="contatti-social-btn contatti-whatsapp-btn"
                >
                  <div className="contatti-social-btn-icon">
                    <i className="fab fa-whatsapp"></i>
                  </div>
                  <div className="contatti-social-btn-content">
                    <div className="contatti-social-btn-title">Scrivici su WhatsApp</div>
                    <div className="contatti-social-btn-subtitle">Mattia - Risposta immediata</div>
                  </div>
                </button>

                <button 
                  onClick={handleInstagramClick}
                  className="contatti-social-btn contatti-instagram-btn"
                >
                  <div className="contatti-social-btn-icon">
                    <i className="fab fa-instagram"></i>
                  </div>
                  <div className="contatti-social-btn-content">
                    <div className="contatti-social-btn-title">Seguici su Instagram</div>
                    <div className="contatti-social-btn-subtitle">@amanti.dello.scoutball</div>
                  </div>
                </button>
              </div>
            </div>
          </section>

          {/* Sezione Form Email - Seconda riga, full width */}
          <section className="contatti-section contatti-email-section">
            <div className="contatti-section-header">
              <h2>
                <i className="fas fa-envelope"></i>
                Invia una Email
              </h2>
            </div>
            <div className="contatti-content">
              {showSuccess && (
                <div className="contatti-success-message">
                  <i className="fas fa-check-circle"></i>
                  Il tuo client email si aprirà per completare l'invio del messaggio.
                </div>
              )}
              
              <form onSubmit={handleSubmit} className="contatti-form">
                <div className="contatti-form-row">
                  <div className={`contatti-form-group ${errors.nome ? 'error' : ''}`}>
                    <label htmlFor="nome">
                      <i className="fas fa-user"></i>
                      Nome <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="nome"
                      value={formData.nome}
                      onChange={(e) => handleInputChange('nome', e.target.value)}
                      placeholder="Il tuo nome"
                      disabled={isSubmitting}
                    />
                    {errors.nome && (
                      <span className="contatti-error-message">
                        <i className="fas fa-exclamation-triangle"></i>
                        {errors.nome}
                      </span>
                    )}
                  </div>

                  <div className={`contatti-form-group ${errors.cognome ? 'error' : ''}`}>
                    <label htmlFor="cognome">
                      <i className="fas fa-user"></i>
                      Cognome <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="cognome"
                      value={formData.cognome}
                      onChange={(e) => handleInputChange('cognome', e.target.value)}
                      placeholder="Il tuo cognome"
                      disabled={isSubmitting}
                    />
                    {errors.cognome && (
                      <span className="contatti-error-message">
                        <i className="fas fa-exclamation-triangle"></i>
                        {errors.cognome}
                      </span>
                    )}
                  </div>
                </div>

                <div className="contatti-form-row single">
                  <div className={`contatti-form-group ${errors.email ? 'error' : ''}`}>
                    <label htmlFor="email">
                      <i className="fas fa-envelope"></i>
                      Email <span className="required">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      value={formData.email}
                      onChange={(e) => handleInputChange('email', e.target.value)}
                      placeholder="la.tua@email.com"
                      disabled={isSubmitting}
                    />
                    {errors.email && (
                      <span className="contatti-error-message">
                        <i className="fas fa-exclamation-triangle"></i>
                        {errors.email}
                      </span>
                    )}
                  </div>
                </div>

                <div className="contatti-form-row single">
                  <div className={`contatti-form-group ${errors.oggetto ? 'error' : ''}`}>
                    <label htmlFor="oggetto">
                      <i className="fas fa-tag"></i>
                      Oggetto <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="oggetto"
                      value={formData.oggetto}
                      onChange={(e) => handleInputChange('oggetto', e.target.value)}
                      placeholder="Oggetto del messaggio"
                      disabled={isSubmitting}
                    />
                    {errors.oggetto && (
                      <span className="contatti-error-message">
                        <i className="fas fa-exclamation-triangle"></i>
                        {errors.oggetto}
                      </span>
                    )}
                  </div>
                </div>

                <div className="contatti-form-row single">
                  <div className={`contatti-form-group ${errors.messaggio ? 'error' : ''}`}>
                    <label htmlFor="messaggio">
                      <i className="fas fa-comment"></i>
                      Messaggio <span className="required">*</span>
                    </label>
                    <textarea
                      id="messaggio"
                      value={formData.messaggio}
                      onChange={(e) => handleInputChange('messaggio', e.target.value)}
                      placeholder="Scrivi qui il tuo messaggio..."
                      disabled={isSubmitting}
                      rows="6"
                    />
                    {errors.messaggio && (
                      <span className="contatti-error-message">
                        <i className="fas fa-exclamation-triangle"></i>
                        {errors.messaggio}
                      </span>
                    )}
                  </div>
                </div>

                <button 
                  type="submit" 
                  className="contatti-submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <div className="contatti-loading-spinner"></div>
                      Preparando email...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-paper-plane"></i>
                      Invia Email
                    </>
                  )}
                </button>
              </form>
            </div>
          </section>

        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Contatti;